import { useCallback } from 'react';
import cl from 'classnames';

import { IconsEnum } from '../../../../../../../../../assets/icons/types';

import { ButtonHelper } from '../../../../../../../../../helpers/buttons/ButtonHelper';
import { Icon } from '../../../../../../../../../helpers/Icon';

type GroupedColor = {
  baseColor: string;
  colors: string[];
};

interface ThreeDStockProductsFiltersColorsFilterItemProps {
  groupedColor: GroupedColor;
  onCheckedColor: (colors: string[], checked: boolean) => void;
  checked: boolean;
}

function ThreeDStockProductsFiltersColorsFilterItem({
  onCheckedColor,
  groupedColor,
  checked
}: ThreeDStockProductsFiltersColorsFilterItemProps) {
  const handleCheck = useCallback(() => {
    onCheckedColor(groupedColor.colors, !checked);
  }, [onCheckedColor, groupedColor, checked]);

  return (
    <ButtonHelper
      className="h-8 w-8 rounded-full flex items-center justify-center hover:bg-opacity-75"
      dataGa={`grouped-color-${groupedColor.baseColor}`}
      onClick={handleCheck}
      style={{
        backgroundColor:
          groupedColor.baseColor === '#ffffff'
            ? '#f5f5f5'
            : groupedColor.baseColor
      }}
    >
      <Icon
        icon={IconsEnum.CHECK}
        className={cl(
          'h-5 w-5',
          groupedColor.baseColor === '#ffffff' ? ' text-black' : ' text-white',
          checked ? '' : 'hidden'
        )}
      />
    </ButtonHelper>
  );
}

export default ThreeDStockProductsFiltersColorsFilterItem;
